import { Maximize2, Minimize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface FileViewerExpandButtonProps {
  expanded: boolean;
  onClick: () => void;
}

/** Icon button that opens a file preview full screen, or exits it when expanded. */
export function FileViewerExpandButton({
  expanded,
  onClick,
}: FileViewerExpandButtonProps) {
  const label = expanded ? "Exit full screen" : "Full screen";
  const Icon = expanded ? Minimize2 : Maximize2;

  return (
    <Tooltip>
      {/* Hover only: a dialog or sheet that focuses this button on open
          would pop the tooltip, and the first Escape would only close it. */}
      <TooltipTrigger asChild onFocus={(event) => event.preventDefault()}>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={label}
          onClick={onClick}
        >
          <Icon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
